export class InvalidOperationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'InvalidOperation';
    }
}
//# sourceMappingURL=invalidOperation.error.js.map